/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SubscriptionComplete
 */
export interface SubscriptionComplete {
    /**
     * 
     * @type {string}
     * @memberof SubscriptionComplete
     */
    redirectUrl: string;
}

/**
 * Check if a given object implements the SubscriptionComplete interface.
 */
export function instanceOfSubscriptionComplete(value: object): value is SubscriptionComplete {
    if (!('redirectUrl' in value) || value['redirectUrl'] === undefined) return false;
    return true;
}

export function SubscriptionCompleteFromJSON(json: any): SubscriptionComplete {
    return SubscriptionCompleteFromJSONTyped(json, false);
}

export function SubscriptionCompleteFromJSONTyped(json: any, ignoreDiscriminator: boolean): SubscriptionComplete {
    if (json == null) {
        return json;
    }
    return {
        
        'redirectUrl': json['redirectUrl'],
    };
}

export function SubscriptionCompleteToJSON(json: any): SubscriptionComplete {
    return SubscriptionCompleteToJSONTyped(json, false);
}

export function SubscriptionCompleteToJSONTyped(value?: SubscriptionComplete | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'redirectUrl': value['redirectUrl'],
    };
}

